// Get segments and store in variables(named after EE segment variables for simplicity)
var newURL = window.location.protocol + "://" + window.location.host + "/" + window.location.pathname;
var pathArray = window.location.pathname.split( '/' ),
		segment_4 = pathArray[4] || null,
		segment_3 = pathArray[3] || null,
		segment_2 = pathArray[2] || null;
		segment_1 = pathArray[1] || null;